import { render, staticRenderFns } from "./QRScannerButton.vue?vue&type=template&id=4f2cd351&scoped=true"
import script from "./QRScannerButton.vue?vue&type=script&setup=true&lang=js"
export * from "./QRScannerButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_lodash@4.17.21_prettier@3.5.3_react@19.0.0_vue-template-c_l4y5rdbexcxjh5nqfbzyfvj2aq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2cd351",
  null
  
)

export default component.exports